
import React, { useState, useEffect } from 'react';
import { financeService } from '../../services/api';
import TransactionList from './TransactionList';
import VATReturn from './VATReturn';

const FinanceDashboard: React.FC = () => {
    const [activeTab, setActiveTab] = useState<'overview' | 'transactions' | 'vat'>('overview');
    const [summary, setSummary] = useState<any>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchSummary();
    }, []);

    const fetchSummary = async () => {
        try {
            const response = await financeService.getSummary();
            if (response.data?.success || response.data) {
                setSummary(response.data?.data || response.data);
            }
        } catch (error) {
            console.error('Error fetching summary:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="p-6 bg-gray-50 min-h-screen">
            <div className="flex items-center mb-6">
                <button
                    onClick={() => window.location.href = '/dashboard'}
                    className="mr-4 text-gray-600 hover:text-gray-900 flex items-center"
                >
                    <i className="fas fa-arrow-left mr-2"></i> Back
                </button>
                <h1 className="text-3xl font-bold text-gray-900">Financial Management</h1>
            </div>

            {/* Tabs */}
            <div className="flex border-b border-gray-200 mb-6">
                <button
                    className={`py-2 px-4 font-medium ${activeTab === 'overview' ? 'text-emerald-600 border-b-2 border-emerald-600' : 'text-gray-500 hover:text-gray-700'}`}
                    onClick={() => setActiveTab('overview')}
                >
                    Overview
                </button>
                <button
                    className={`py-2 px-4 font-medium ${activeTab === 'transactions' ? 'text-emerald-600 border-b-2 border-emerald-600' : 'text-gray-500 hover:text-gray-700'}`}
                    onClick={() => setActiveTab('transactions')}
                >
                    Transactions
                </button>
                <button
                    className={`py-2 px-4 font-medium ${activeTab === 'vat' ? 'text-emerald-600 border-b-2 border-emerald-600' : 'text-gray-500 hover:text-gray-700'}`}
                    onClick={() => setActiveTab('vat')}
                >
                    MTD VAT Return
                </button>
            </div>

            {/* Content */}
            {activeTab === 'overview' && (
                <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
                    <div className="bg-white p-6 rounded-lg shadow">
                        <h3 className="text-gray-500 text-sm font-medium">Total Income</h3>
                        <p className="text-2xl font-bold text-green-600">
                            {loading ? '...' : `£${summary?.totalIncome?.toFixed(2) || '0.00'}`}
                        </p>
                    </div>
                    <div className="bg-white p-6 rounded-lg shadow">
                        <h3 className="text-gray-500 text-sm font-medium">Total Expenses</h3>
                        <p className="text-2xl font-bold text-red-600">
                            {loading ? '...' : `£${summary?.totalExpenses?.toFixed(2) || '0.00'}`}
                        </p>
                    </div>
                    <div className="bg-white p-6 rounded-lg shadow">
                        <h3 className="text-gray-500 text-sm font-medium">Net Profit</h3>
                        <p className={`text-2xl font-bold ${summary?.netProfit >= 0 ? 'text-gray-900' : 'text-red-600'}`}>
                            {loading ? '...' : `£${summary?.netProfit?.toFixed(2) || '0.00'}`}
                        </p>
                    </div>
                    <div className="bg-white p-6 rounded-lg shadow">
                        <h3 className="text-gray-500 text-sm font-medium">Est. Tax (20%)</h3>
                        <p className="text-2xl font-bold text-orange-600">
                            {loading ? '...' : `£${summary?.estimatedTax?.toFixed(2) || '0.00'}`}
                        </p>
                    </div>
                </div>
            )}

            {activeTab === 'transactions' && <TransactionList />}
            {activeTab === 'vat' && <VATReturn />}
        </div>
    );
};

export default FinanceDashboard;
